import { render, staticRenderFns } from "./SemiologiaTraumatologica.vue?vue&type=template&id=585fb076"
import script from "./SemiologiaTraumatologica.vue?vue&type=script&lang=js"
export * from "./SemiologiaTraumatologica.vue?vue&type=script&lang=js"
import style0 from "./SemiologiaTraumatologica.vue?vue&type=style&index=0&id=585fb076&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports